import { useEffect, useState } from 'react';

export default function useNavigatorInfo() {
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    const checkSafari = () => {
      const ua = navigator.userAgent;
      const isSafariBrowser =
        /^((?!chrome|android|crios|edg|opr|fxios).)*safari/i.test(ua);
      setIsSafari(isSafariBrowser);
    };

    checkSafari();

    window.addEventListener('resize', checkSafari);

    return () => {
      window.removeEventListener('resize', checkSafari);
    };
  }, []);

  return { isSafari };
}
